import React, { Component } from 'react';
import { Col, Card, CardTitle, CardBody, Progress } from 'reactstrap';
import NumberFormat from 'react-number-format';
import ReactApexChart from 'react-apexcharts';
import ReactEcharts from 'echarts-for-react';
import { countryOptions } from '../../helpers/country_helper';
import { Link } from 'react-router-dom';

class GraphComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: ['primary', 'success', 'warning', 'info', 'danger'],
      ordersCountries: true,
      ordersClients: true,
      pieChartClientsSwitcher: false,
      pieChartCountriesSwitcher: false,
      toggleExpandCountries: false,
      toggleExpandClients: false,
      salesClientsData: [],
      salesCountriesData: []
    };
    this.weeklyStatInfo = this.weeklyStatInfo.bind(this);
    this.getSum = this.getSum.bind(this);
    this.sortCountriesData = this.sortCountriesData.bind(this);
    this.sortClientsData = this.sortClientsData.bind(this);
    this.countPercentageCountries = this.countPercentageCountries.bind(this);
    this.countPercentageClients = this.countPercentageClients.bind(this);
    this.displayChartCountriesData = this.displayChartCountriesData.bind(this);
    this.displayChartClientsData = this.displayChartClientsData.bind(this);
  }
  /**
   * Display data for last 8 weeks
   * @param {*} arg
   * @returns
   */
  weeklyStatInfo = (arg) => {
    const { weeklyData, weeksRange } = this.props.props;
    let weeksRangeArr = [];
    // let weeklyDataArr = new Array(12).fill(0); // Initialize array with 12 zeros
    let weeklyDataArr = new Array();
    for (let i = 0; i < weeklyData.length; i++) {
      weeklyDataArr[i] = weeklyData[i].totalSaleAmount;
    }
    weeklyDataArr = weeklyDataArr;
    if (weeksRange.includes('January')) {
      weeksRange.map((info, key) => {
        weeksRangeArr.push(weeksRange[key]);
        return weeksRangeArr;
      });
    } else {
      weeksRange.map((info, key) => {
        weeksRangeArr.push(new Date(weeksRange[key]['monday']).toLocaleDateString('en-GB') + '-' + new Date(weeksRange[key]['sunday']).toLocaleDateString('en-GB'));
        return weeksRangeArr;
      });
    }
    weeklyDataArr = weeklyDataArr.filter(item => item !== null);
    const dataChart = {
      series: [
        {
          name: 'Sales',
          data: weeklyDataArr
        }
      ],
      options: {
        chart: {
          dropShadow: {
            enabled: !0,
            color: '#000',
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.6
          },
          color: '#556ee6'
          // height: 'auto'
        },
        title: {
          text: this.props.props.title,
          align: 'center',
          style: {
            fontSize: '16px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#000000'
          }
        },
        labels: weeksRangeArr,
        stroke: {
          curve: 'smooth',
          width: 3
        },
        colors: ['#556ee6'],
        // markers: {
        //   size: 5,
        //   hover: {
        //     size: 9
        //   }
        // },
        yaxis: {
          labels: {
            formatter: function (value) {
              //Setup new Formatting class variable
              var Formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
              });

              return Formatter.format(value);
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            var Formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            });
            return Formatter.format(val);
          }
          // style: {
          //   colors: ['#333', '#333', '#333', '#333']
          // },
        }
      }
    };
    return dataChart;
  };
  /**
   * Get sum for a given value
   * @param {*} prop
   * @param {*} items
   * @returns
   */
  getSum = function (prop, items) {
    return items.reduce(function (a, b) {
      return a + b[prop];
    }, 0);
  };
  /**
   * Get name of the country
   * @param {*} country
   * @returns
   */
  getCountryName = (country) => countryOptions.find((o) => o.value === country).text;
  /**
   * Sort Countries
   */
  sortCountriesData = () => {
    const { countryStats } = this.props.props;
    let salesCountriesData = [];
    if (this.state.ordersCountries !== true) {
      salesCountriesData = countryStats.sort((a, b) => parseFloat(b.noOfOrders) - parseFloat(a.noOfOrders));
    } else {
      salesCountriesData = countryStats.sort((a, b) => parseFloat(b.totalSaleAmount) - parseFloat(a.totalSaleAmount));
    }
    this.setState({ salesCountriesData: salesCountriesData });
  };
  /**
   * Sort Clients
   */
  sortClientsData = () => {
    const { clientsStats } = this.props.props;
    let salesClientsData = [];
    if (this.state.ordersClients !== true) {
      salesClientsData = clientsStats.sort((a, b) => parseFloat(b.noOfOrders) - parseFloat(a.noOfOrders));
    } else {
      salesClientsData = clientsStats.sort((a, b) => parseFloat(b.totalSaleAmount) - parseFloat(a.totalSaleAmount));
    }
    this.setState({ salesClientsData: salesClientsData });
  };
  /**
   * Count percentage of countries
   * @param {*} value1
   * @returns
   */
  countPercentageCountries = (value1) => {
    const { curInfo } = this.props.props;
    const { ordersCountries } = this.state;
    const periodSum = ordersCountries ? curInfo.amountOfAllOrders : curInfo.totalSaleAmount;
    const sum = (value1 * 100) / periodSum;
    return sum.toFixed(2);
  };
  /**
   * Count percentage of clients
   * @param {*} value1
   * @returns
   */
  countPercentageClients = (value1) => {
    const { curInfo } = this.props.props;
    const { ordersClients } = this.state;
    const periodSum = ordersClients ? curInfo.amountOfAllOrders : curInfo.totalSaleAmount;
    const sum = (value1 * 100) / periodSum;
    return sum.toFixed(2);
  };
  /**
   * Display countries in pie chart
   * @returns
   */
  displayChartCountriesData = () => {
    const { countryStats } = this.props.props;
    const { ordersCountries } = this.state;
    let data = [];
    let total = ordersCountries === true ? this.getSum('noOfOrders', countryStats) : this.getSum('totalSaleAmount', countryStats);
    countryStats.map((info, key) => {
      data.push({
        value: ordersCountries === true ? countryStats[key]['noOfOrders'] : countryStats[key]['totalSaleAmount'],
        name: `${this.getCountryName(countryStats[key]['_id']['country'])} - ${
          ordersCountries === true ? ((countryStats[key]['noOfOrders'] * 100) / total).toFixed(1) : ((countryStats[key]['totalSaleAmount'] * 100) / total).toFixed(1)
        }%`
      });
      return data;
    });
    const dataChart = {
      toolbox: {
        show: false
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} asdasds <br/>{b} : {c} ({d}%)'
      },
      color: ['#f46a6a', '#34c38f', '#50a5f1', '#f1b44c', '#556ee6'],
      series: [
        {
          name: `${this.state.ordersCountries === true ? 'Total Orders' : 'Total Sales'}`,
          type: 'pie',
          radius: '75%',
          center: ['50%', '50%'],
          data: data,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    return dataChart;
  };
  /**
   * Display clients in pie chart
   * @returns
   */
  displayChartClientsData = () => {
    const { clientsStats } = this.props.props;
    const { ordersClients } = this.state;
    let data = [];
    let total = ordersClients === true ? this.getSum('noOfOrders', clientsStats) : this.getSum('totalSaleAmount', clientsStats);
    clientsStats.map((info, key) => {
      data.push({
        value: ordersClients === true ? clientsStats[key]['noOfOrders'] : clientsStats[key]['totalSaleAmount'],
        name: `${clientsStats[key]['_id']['clientName']} - ${
          ordersClients === true ? ((clientsStats[key]['noOfOrders'] * 100) / total).toFixed(1) : ((clientsStats[key]['totalSaleAmount'] * 100) / total).toFixed(1)
        }%`
      });
      return data;
    });
    const dataChart = {
      toolbox: {
        show: false
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} asdasds <br/>{b} : {c} ({d}%)'
      },
      color: ['#f46a6a', '#34c38f', '#50a5f1', '#f1b44c', '#556ee6'],
      series: [
        {
          name: `${this.state.ordersClients === true ? 'Total Orders' : 'Total Sales'}`,
          type: 'pie',
          radius: '75%',
          center: ['50%', '50%'],
          data: data,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    return dataChart;
  };
  render() {
    const { toggleExpandCountries, toggleExpandClients, pieChartCountriesSwitcher, pieChartClientsSwitcher, ordersCountries, ordersClients, colors } = this.state;
    const { countryStats, clientsStats } = this.props.props;
    return (
      <React.Fragment>
        <Col sm='6'>
          <Card>
            <CardBody>
              <div id='line-chart' className='apex-charts' dir='ltr'>
                <ReactApexChart series={this.weeklyStatInfo().series} options={this.weeklyStatInfo().options} type='line' height={420} className='apex-charts' />
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col sm='3' className={toggleExpandCountries ? 'overlay' : ''}>
          <Card id='pie-style' className={toggleExpandCountries ? 'pie-fullscreen' : ''}>
            <CardTitle className='mt-2 h4 align-items-center'>
              <div className='d-flex'>
                <div className='form-check form-switch form-switch-lg mb-3 ms-4'>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    id='customSwitchsizelg'
                    onClick={() => {
                      this.setState({ pieChartCountriesSwitcher: !pieChartCountriesSwitcher });
                    }}
                  />
                  <label className='form-check-label' htmlFor='customSwitchsizelg'>
                    {' '}
                    Pie Chart{' '}
                  </label>
                </div>
                <div className='ms-auto'>
                  <ul className='nav nav-pills'>
                    <li className='nav-item'>
                      <Link
                        to='#'
                        className={ordersCountries ? 'active nav-link' : 'nav-link'}
                        onClick={(e) => {
                          this.setState({ ordersCountries: true, salesCountries: false });
                          this.sortCountriesData();
                        }}
                      >
                        Orders
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <Link
                        to='#'
                        className={!ordersCountries ? 'active nav-link' : 'nav-link'}
                        onClick={(e) => {
                          this.setState({ ordersCountries: false, salesCountries: true });
                          this.sortCountriesData();
                        }}
                      >
                        Sales
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <span className='expand-pie' onClick={() => this.setState({ toggleExpandCountries: !toggleExpandCountries })}>
                        <i className='bx bx-expand m-2 font-size-22' />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </CardTitle>
            <CardBody>
              {countryStats.length !== 0 && (
                <>
                  {!pieChartCountriesSwitcher ? (
                    <>
                      <div className='text-center'>
                        <div className='mb-4'>
                          <i className='bx bx-map-pin text-primary display-4' style={{ lineHeight: '1' }} />
                        </div>
                        <h3>
                          <b>Statistics by Countries</b>
                        </h3>
                        <p>
                          {this.getCountryName(countryStats[0]._id.country)}{' '}
                          {ordersCountries === true ? (
                            countryStats[0]['noOfOrders']
                          ) : (
                            <NumberFormat value={countryStats[0]['totalSaleAmount']} displayType='text' thousandSeparator={true} prefix='$' />
                          )}
                        </p>
                      </div>
                      <div className='table-responsive country-list mt-4'>
                        <table className='table align-middle table-nowrap'>
                          <tbody>
                            {countryStats.map((id, index) => {
                              return (
                                <tr key={index}>
                                  <td style={{ width: '30%' }}>
                                    <p className='mb-0 '>{this.getCountryName(id['_id'].country)}</p>
                                  </td>
                                  <td style={{ width: '25%' }}>
                                    <p className='mb-0 ps-5'>
                                      {ordersCountries === true ? (
                                        <>
                                          {id.noOfOrders} ({this.countPercentageCountries(id.noOfOrders)}%)
                                        </>
                                      ) : (
                                        <>
                                          <NumberFormat value={id.totalSaleAmount} displayType='text' thousandSeparator={true} prefix='$' /> ({this.countPercentageCountries(id.totalSaleAmount)}
                                          %)
                                        </>
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    {ordersCountries === true ? (
                                      <Progress value={this.countPercentageCountries(id.noOfOrders)} color={this.state.colors[index]} className='progress bg-transparent progress-sm' size='sm' />
                                    ) : (
                                      <Progress value={this.countPercentageCountries(id.totalSaleAmount)} color={this.state.colors[index]} className='progress bg-transparent progress-sm' size='sm' />
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <ReactEcharts style={{ height: toggleExpandCountries ? '600px' : '350px' }} option={this.displayChartCountriesData()} />
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
        <Col sm='3' className={toggleExpandClients ? 'overlay' : ''}>
          <Card id='pie-style-2' className={toggleExpandClients ? 'pie-fullscreen' : ''}>
            <CardTitle className='mt-2 h4 align-items-center'>
              <div className='d-flex'>
                <div className='form-check form-switch form-switch-lg mb-3 ms-4'>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    id='customSwitchsizelg'
                    onClick={() => {
                      this.setState({ pieChartClientsSwitcher: !pieChartClientsSwitcher });
                    }}
                  />
                  <label className='form-check-label' htmlFor='customSwitchsizelg'>
                    {' '}
                    Pie Chart{' '}
                  </label>
                </div>
                <div className='ms-auto'>
                  <ul className='nav nav-pills'>
                    <li className='nav-item'>
                      <Link
                        to='#'
                        className={ordersClients ? 'active nav-link' : 'nav-link'}
                        onClick={(e) => {
                          this.setState({ ordersClients: true, salesClients: false });
                          this.sortClientsData();
                        }}
                      >
                        Orders
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <Link
                        to='#'
                        className={!ordersClients ? 'active nav-link' : 'nav-link'}
                        onClick={(e) => {
                          this.setState({ ordersClients: false, salesClients: true });
                          this.sortClientsData();
                        }}
                      >
                        Sales
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <span className='expand-pie' onClick={() => this.setState({ toggleExpandClients: !toggleExpandClients })}>
                        <i className='bx bx-expand m-2 font-size-22' />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </CardTitle>
            <CardBody>
              {clientsStats.length !== 0 && (
                <>
                  {!pieChartClientsSwitcher ? (
                    <>
                      <div className='text-center'>
                        <div className='mb-4'>
                          <i className='bx bx-map-pin text-primary display-4' style={{ lineHeight: '1' }} />
                        </div>
                        <h3>
                          <b>Statistics by Clients</b>
                        </h3>
                        <p>
                          {clientsStats[0]['_id']['clientName']}{' '}
                          {ordersClients ? clientsStats[0]['noOfOrders'] : <NumberFormat value={clientsStats[0]['totalSaleAmount']} displayType='text' thousandSeparator={true} prefix='$' />}
                        </p>
                      </div>
                      <div className='table-responsive country-list mt-4'>
                        <table className='table align-middle table-nowrap'>
                          <tbody>
                            {clientsStats.map((id, index) => {
                              return (
                                <tr key={index}>
                                  <td style={{ width: '30%' }}>
                                    <p className='mb-0 '>{id['_id']['clientName']}</p>
                                  </td>
                                  <td style={{ width: '25%' }}>
                                    <p className='mb-0 ps-5'>
                                      {ordersClients ? (
                                        <>
                                          {' '}
                                          {id.noOfOrders} ({this.countPercentageClients(id.noOfOrders)}%){' '}
                                        </>
                                      ) : (
                                        <>
                                          <NumberFormat value={id.totalSaleAmount} displayType='text' thousandSeparator={true} prefix='$' /> ({this.countPercentageClients(id.totalSaleAmount)}
                                          %)
                                        </>
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    {ordersClients === true ? (
                                      <Progress value={this.countPercentageClients(id.noOfOrders)} color={colors[index]} className='progress bg-transparent progress-sm' size='sm' />
                                    ) : (
                                      <Progress value={this.countPercentageClients(id.totalSaleAmount)} color={colors[index]} className='progress bg-transparent progress-sm' size='sm' />
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <ReactEcharts style={{ height: toggleExpandClients ? '600px' : '350px' }} option={this.displayChartClientsData()} />
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

export default GraphComp;
